module.exports = __webpack_public_path__ + "static/media/kodiranePlombe4.16ddeb54.JPG";